export const InventoryPill = ({children = <></>, className = "", innerClassName = ""}) => {
    return (
        <div className={className}>
            <span className={"items-center px-2.5 py-0.5 rounded-full text-xs font-medium " + innerClassName}>
                {children}
            </span>
        </div>
    )
}
